(function() {
  // Multi-currency thresholds
  const THRESHOLDS = {
    'SEK': 500,
    'DKK': 370,
    'EUR': 45,
    'NOK': 550,
    'USD': 50
  };
  
  const BAR_ID = 'free-shipping-bar-container';
  let currentCurrency = 'SEK'; // Default
  
  function getCurrency() {
    // Try to get currency from Shopify
    if (window.Shopify && window.Shopify.currency) {
      return window.Shopify.currency.active;
    }
    
    // Fallback: check meta tag
    const metaTag = document.querySelector('meta[property="og:locale"]');
    if (metaTag) {
      const locale = metaTag.getAttribute('content');
      if (locale.includes('sv')) return 'SEK';
      if (locale.includes('da')) return 'DKK';
      if (locale.includes('de')) return 'EUR';
      if (locale.includes('no')) return 'NOK';
    }
    
    // Fallback: check URL or document lang
    const lang = document.documentElement.lang || navigator.language;
    if (lang.includes('sv')) return 'SEK';
    if (lang.includes('da')) return 'DKK';
    if (lang.includes('de')) return 'EUR';
    if (lang.includes('no')) return 'NOK';
    
    return 'SEK'; // Default to SEK
  }
  
  function getThreshold() {
    currentCurrency = getCurrency();
    return THRESHOLDS[currentCurrency] || THRESHOLDS['SEK'];
  }
  
  function createBar() {
    // Check if bar already exists
    if (document.getElementById(BAR_ID)) {
      return;
    }
    
    const bar = document.createElement('div');
    bar.id = BAR_ID;
    bar.className = 'free-shipping-bar hidden';
    bar.innerHTML = `
      <div id="shipping-text">Add products for free shipping!</div>
      <div class="shipping-progress">
        <div class="shipping-progress-fill" id="shipping-fill" style="width: 0%"></div>
      </div>
      <div class="shipping-message" id="shipping-message"></div>
    `;
    
    // Add bar before main content
    const mainContent = document.getElementById('MainContent');
    if (mainContent) {
      mainContent.parentNode.insertBefore(bar, mainContent);
    } else {
      document.body.insertBefore(bar, document.body.firstChild);
    }
  }
  
  function updateBar() {
    const bar = document.getElementById(BAR_ID);
    if (!bar) return;
    
    // Fetch cart data from Shopify
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const threshold = getThreshold();
        const cartTotal = cart.total_price / 100; // Convert from öre to currency unit
        const percentage = Math.min((cartTotal / threshold) * 100, 100);
        const remaining = Math.max(threshold - cartTotal, 0);
        
        const textEl = document.getElementById('shipping-text');
        const fillEl = document.getElementById('shipping-fill');
        const messageEl = document.getElementById('shipping-message');
        
        if (cartTotal >= threshold) {
          textEl.textContent = '🎉 You have free shipping!';
          bar.classList.remove('hidden');
          fillEl.style.width = '100%';
          messageEl.textContent = '';
        } else {
          bar.classList.remove('hidden');
          textEl.textContent = `Add ${remaining.toFixed(0)} ${currentCurrency} for free shipping`;
          fillEl.style.width = percentage + '%';
          messageEl.textContent = `${cartTotal.toFixed(0)} / ${threshold} ${currentCurrency}`;
        }
      })
      .catch(error => console.error('Error fetching cart:', error));
  }
  
  // Create bar when page loads
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      createBar();
      updateBar();
    });
  } else {
    createBar();
    updateBar();
  }
  
  // Listen for cart updates via PubSub (Shopify's built-in system)
  if (window.PubSub) {
    PubSub.subscribe('cart:updated', updateBar);
    PubSub.subscribe('cart:change', updateBar);
  }
  
  // Listen for custom events from cart drawer
  document.addEventListener('cart:updated', updateBar);
  document.addEventListener('cart:change', updateBar);
  
  // Observe DOM changes for cart drawer
  const observer = new MutationObserver(function(mutations) {
    updateBar();
  });
  
  // Start observation when DOM is ready
  setTimeout(() => {
    const cartDrawer = document.querySelector('[id*="cart"]');
    if (cartDrawer) {
      observer.observe(cartDrawer, {
        childList: true,
        subtree: true,
        attributes: true
      });
    }
  }, 1000);
})();